var frifeldt = frifeldt || {};
( function () {
    'use strict';
    jQuery( function () {
        frifeldt.init();
    } );
    frifeldt.init = function () {
        frifeldt.floorPlan.init();
        frifeldt.bannerZoom.init();
        frifeldt.imageModal.init();
        frifeldt.chromatic();
        frifeldt.recaptcha.init();
        frifeldt.activecampaign.init();
    };
    frifeldt.floorPlan = {
        init: function () { 
            frifeldt.floorPlan.bindEvents();
        },
        bindEvents: function () {
            var floorPlanCard = jQuery( '.js-card-open' );
            floorPlanCard.on( 'click', function() {
                var clickedCard = jQuery(this);
                var clickedCardImage = clickedCard.attr("data-image-big");
                var clickedCardPdf = clickedCard.attr("data-image-pdf");
                var clickedCardPdfText = clickedCard.attr("data-image-pdf-text");

                jQuery( '.row ').removeClass("clicked-row");
                jQuery( '#active-row' ).remove();

                clickedCard.closest( '.row ').addClass("clicked-row");
                clickedCard.closest( '.row ').after( '<div id="active-row" class="row ">' + 
                                                    '<div class="col-12">' +
                                                    '<div class="card-showmore mb-4 px-4 py-4 bg-gradient-primary">' +
                                                    '<div class="row">' + 
                                                    '<div class="col-12 col-md-6">' +
                                                    '<img src="' + clickedCardImage + '" id="floorplan-img-big" class="img-fluid" />' +
                                                    '</div>' +
                                                    '<div class="col-12 col-md-6">' +
                                                    '<div class="image-text">' +
                                                    '<a href="' + clickedCardPdf + '" class="text-white">' + clickedCardPdfText + '</a>' +
                                                    '</div>' +
                                                    '</div>' +
                                                    '</div>' +
                                                    '</div>' +
                                                    '</div>' +
                                                    '</div>' );

                // Scroll to active row
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#active-row").offset().top - 100
                }, 1000);

                var floorplanImgBig = jQuery( '#floorplan-img-big' );
                var floorplanImgModal = jQuery( '.js-floorplan-modal' );
                if (floorplanImgBig.length > 0) {
                    floorplanImgBig.on( 'click', function() {
                        var floorplanImgBigPath = floorplanImgBig.attr( 'src' );
                        floorplanImgModal.find( 'img' ).attr( 'src', floorplanImgBigPath );
                        floorplanImgModal.modal();
                    });
                }
            });
        }
    };
    frifeldt.bannerZoom = {
        animationEnd: 'webkitAnimationEnd oAnimationEnd oTransitionEnd animationend',
        transitionDelay: 0,
        init: function () {
            frifeldt.bannerZoom.loadImages();
            frifeldt.bannerZoom.bindEvents();
        },
        loadImages: function () {
            jQuery( '.js-e-banner-zoom-image' ).each( function () {
                jQuery( this ).attr( 'src', this.getAttribute( 'data-src' ) );
            } );
        },
        bindEvents: function () {
            var jFirstImage = jQuery( '.js-e-banner-zoom' ).find( '.js-e-banner-zoom-image' ).first();
            jFirstImage.addClass( 'e-banner-zoom-image-animate-in' );
            frifeldt.bannerZoom.transitionDelay = parseFloat( jFirstImage.css( 'transition-duration' ) ) * 1000;

            jQuery( '.js-e-banner-zoom' ).on( frifeldt.bannerZoom.animationEnd, '.js-e-banner-zoom-image', function () {
                frifeldt.bannerZoom.animate( this );
            } );
        },
        animate: function ( domElm ) {
            var jImage = jQuery( domElm );
            jImage.toggleClass( 'e-banner-zoom-image-animate-in e-banner-zoom-image-animate-out' );
            if ( jImage.next().is( '.js-e-banner-zoom-image' ) === true ) {
                jImage.next().addClass( 'e-banner-zoom-image-animate-in' );
            }
            else {
                jQuery( '.js-e-banner-zoom' ).find( '.js-e-banner-zoom-image' ).first().addClass( 'e-banner-zoom-image-animate-in' );
            }
            setTimeout( function () {
                jImage.removeClass( 'e-banner-zoom-image-animate-out' );
            }, frifeldt.bannerZoom.transitionDelay );
        }

    };
    frifeldt.chromatic = function() {
        var jChromatic = jQuery( '.js-e-chromatic' );
        if ( jChromatic.length > 0 ) {
            jChromatic.each( function () {
                var jChromaticGallery = jQuery( this ),
                    jChromaticGalleryItems = jChromaticGallery.find( '.js-e-chromatic-item' ),
                    arrChromaticImages = [];
                jChromaticGalleryItems.each( function () {
                    var jThis = jQuery( this ),
                        jThisImage = jThis.find( '.js-e-chromatic-img' );
                    arrChromaticImages.push( {
                        small: jThisImage.attr( 'src' ),
                        big: jThisImage.data( 'large-src' ),
                        caption: jQuery.trim( jThis.find( '.js-e-chromatic-caption' ).html() )
                    } );
                } );
                jChromaticGallery.empty().chromatic( arrChromaticImages );
            } );
        }
    };
    frifeldt.imageModal = {
        init: function () {
            frifeldt.imageModal.openModal();
        },
        openModal: function () {
            jQuery('.frifeldt-modal-paragraph').find('a').each(function(){
                jQuery(this).on('click', function(event){
                    var jImg = jQuery(this).closest('.frifeldt-modal-paragraph').find('img').attr('src');
                    jQuery('.js-frifeldt-image-modal-image').attr('src', jImg);
                    jQuery('.js-frifeldt-image-modal').modal('show');
                    event.preventDefault();
                });
            });
        }
    };
    frifeldt.recaptcha = {
        init: function () {
            frifeldt.recaptcha.bindEvents();
        },
        bindEvents: function () {
            var jHiddenRecaptcha = jQuery( 'input[name="recaptcha"]' ),
                jForm = jHiddenRecaptcha.closest( 'form' ),
                strSiteKey = '6LdJhAMoAAAAAC6rArUHbgp3m0fHcYgYvFRxajXU';
                //strSecretKey = '';

            setTimeout( function () {
                if ( jHiddenRecaptcha.length > 0 ) {
                    // Clear recaptcha field
                    jHiddenRecaptcha.val('');
                    
                    // Add recaptcha to form
                    jForm.each(function(index){
                        jQuery(this).find( '.form-actions' ).before( '<div id=\'recaptchaid' + index + '\'></div> <div class=\'d-none js-frifeldt-recaptcha-error-msg frifeldt-recaptcha-error-msg\'><small>Dette felt er påkrævet</small></div>' );
                    
                        grecaptcha.render( 'recaptchaid' + index, {
                            'sitekey': strSiteKey
                        } );
                    
                        if ( jQuery(this).hasClass('frifeldt-dw-form-validate') ) {
                            jQuery(this).find('input[name="recaptcha"]').addClass('required');
                            //jQuery(this).data( 'validator' ).settings.ignore = '';
                            jQuery(this).on( 'click', 'button[type=submit]', function () {
                                if ( grecaptcha.getResponse() === '' ) {
                                    console.log('g recap bad');
                                    jQuery(this).closest('form').find( '.js-frifeldt-recaptcha-error-msg' ).removeClass( 'd-none' );
                                    jQuery(this).closest('form').find( '#recaptchaid' + index ).addClass( 'recaptcha-error' );
                                }
                                else {
                                    console.log('g recap good');
                                    jQuery(this).closest('form').find( '.js-frifeldt-recaptcha-error-msg' ).addClass( 'd-none' );
                                    jQuery(this).closest('form').find( '#recaptchaid' + index ).removeClass( 'recaptcha-error' );
                                }
                            } );
                            jQuery(this).find('input[name="recaptcha"]').rules( 'add', {
                                required: function () {
                                    if ( grecaptcha.getResponse() === '' ) {
                                        return true;
                                    }
                                    else {
                                        return false;
                                    }
                                }
                            } );
                            jQuery(this).validate( {
                                submitHandler: function ( form ) {
                                    form.submit();
                                }
                            } );
                        }
                    });
                    /*<noscript><div><div style=\'width: 302px; height: 422px; position: relative;\'><div style=\'width: 302px; height: 422px; position: absolute;\'><iframe src=\'https://www.google.com/recaptcha/api/fallback?k=' + strSiteKey + '\' frameborder=\'0\' scrolling=\'no\' style=\'width: 302px; height:422px; border-style: none;\'></iframe></div></div><div style=\'width: 300px; height: 60px; border-style: none; bottom: 12px; left: 25px; margin: 0px; padding: 0px; right: 25px; background: #f9f9f9; border: 1px solid #c1c1c1; border-radius: 3px;\'><textarea id=\'g-recaptcha-response\' name=\'g-recaptcha-response\' class=\'g-recaptcha-response\' style=\'width: 250px; height: 40px; border: 1px solid #c1c1c1; margin: 10px 25px; padding: 0px; resize: none;\'></textarea></div></div></noscript>*/
                }
            }.bind( this ), 1000 );
        }
    };
    frifeldt.activecampaign = {
        init: function () { 
            frifeldt.activecampaign.bindEvents();
        },
        bindEvents: function () {
            window.cfields = [];
            window._show_thank_you = function(id, message, trackcmp_url, email) {
                var form = document.getElementById('_form_' + id + '_'), thank_you = form.querySelector('._form-thank-you');
                form.querySelector('._form-content').style.display = 'none';
                thank_you.innerHTML = message;
                thank_you.style.display = 'block';
                const vgoAlias = typeof visitorGlobalObjectAlias === 'undefined' ? 'vgo' : visitorGlobalObjectAlias;
                var visitorObject = window[vgoAlias];
                if (email && typeof visitorObject !== 'undefined') {
                    visitorObject('setEmail', email);
                    visitorObject('update');
                } else if (typeof(trackcmp_url) != 'undefined' && trackcmp_url) {
                    // Site tracking URL to use after inline form submission.
                    _load_script(trackcmp_url);
                }
                if (typeof window._form_callback !== 'undefined') window._form_callback(id);
            };
            window._show_error = function(id, message, html) {
                var form = document.getElementById('_form_' + id + '_'), err = document.createElement('div'), button = form.querySelector('button'), old_error = form.querySelector('._form_error');
                if (old_error) old_error.parentNode.removeChild(old_error);
                err.innerHTML = message;
                err.className = '_error-inner _form_error _no_arrow';
                var wrapper = document.createElement('div');
                wrapper.className = '_form-inner';
                wrapper.appendChild(err);
                button.parentNode.insertBefore(wrapper, button);
                document.querySelector('[id^="_form"][id$="_submit"]').disabled = false;
                if (html) {
                    var div = document.createElement('div');
                    div.className = '_error-html';
                    div.innerHTML = html;
                    err.appendChild(div);
                }
            };
            window._load_script = function(url, callback) {
                var head = document.querySelector('head'), script = document.createElement('script'), r = false;
                script.type = 'text/javascript';
                script.charset = 'utf-8';
                script.src = url;
                if (callback) {
                    script.onload = script.onreadystatechange = function() {
                        if (!r && (!this.readyState || this.readyState == 'complete')) {
                            r = true;
                            callback();
                        }
                    };
                }
                head.appendChild(script);
            };
            (function() {
                if (window.location.search.search("excludeform") !== -1) return false;
                var getCookie = function(name) {
                    var match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]+)'));
                    return match ? match[2] : null;
                }
                var setCookie = function(name, value) {
                    var now = new Date();
                    var time = now.getTime();
                    var expireTime = time + 1000 * 60 * 60 * 24 * 365;
                    now.setTime(expireTime);
                    document.cookie = name + '=' + value + '; expires=' + now + ';path=/';
                }
                var addEvent = function(element, event, func) {
                    if (element != null) {
                        if (element.addEventListener) {
                            element.addEventListener(event, func);
                        } else {
                            var oldFunc = element['on' + event];
                            element['on' + event] = function() {
                                oldFunc.apply(this, arguments);
                                func.apply(this, arguments);
                            };
                        }
                    }
                }
                var _removed = false;
                var form_to_submit = document.getElementById('_form_4_');
                var allInputs = [];
                var tooltips = [];
                var getUrlParam = function(name) {
                    var regexStr = '[\?&]' + name + '=([^&#]*)';
                    var results = new RegExp(regexStr, 'i').exec(window.location.href);
                    return results != undefined ? decodeURIComponent(results[1]) : false;
                };

                if (form_to_submit !== null) {
                    allInputs = form_to_submit.querySelectorAll('input, select, textarea'), tooltips = [], submitted = false;

                    for (var i = 0; i < allInputs.length; i++) {
                        var regexStr = "field\\[(\\d+)\\]";
                        var results = new RegExp(regexStr).exec(allInputs[i].name);
                        if (results != undefined) {
                            allInputs[i].dataset.name = window.cfields[results[1]];
                        } else {
                            allInputs[i].dataset.name = allInputs[i].name;
                        }
                        var fieldVal = getUrlParam(allInputs[i].dataset.name);

                        if (fieldVal) {
                            if (allInputs[i].dataset.autofill === "false") {
                                continue;
                            }
                            if (allInputs[i].type == "radio" || allInputs[i].type == "checkbox") {
                                if (allInputs[i].value == fieldVal) {
                                    allInputs[i].checked = true;
                                }
                            } else {
                                allInputs[i].value = fieldVal;
                            }
                        }
                    }
                }

                var remove_tooltips = function() {
                    for (var i = 0; i < tooltips.length; i++) {
                        tooltips[i].tip.parentNode.removeChild(tooltips[i].tip);
                    }
                    tooltips = [];
                };
                var remove_tooltip = function(elem) {
                    for (var i = 0; i < tooltips.length; i++) {
                        if (tooltips[i].elem === elem) {
                            tooltips[i].tip.parentNode.removeChild(tooltips[i].tip);
                            tooltips.splice(i, 1);
                            return;
                        }
                    }
                };
                var create_tooltip = function(elem, text) {
                    var tooltip = document.createElement('div'), arrow = document.createElement('div'), inner = document.createElement('div'), new_tooltip = {};
                    if (elem.type != 'radio' && elem.type != 'checkbox') {
                        tooltip.className = '_error';
                        arrow.className = '_error-arrow';
                        inner.className = '_error-inner';
                        inner.innerHTML = text;
                        tooltip.appendChild(arrow);
                        tooltip.appendChild(inner);
                        elem.parentNode.appendChild(tooltip);
                    } else {
                        tooltip.className = '_error-inner _no_arrow';
                        tooltip.innerHTML = text;
                        elem.parentNode.insertBefore(tooltip, elem);
                        new_tooltip.no_arrow = true;
                    }
                    new_tooltip.tip = tooltip;
                    new_tooltip.elem = elem;
                    tooltips.push(new_tooltip);
                    return new_tooltip;
                };
                var resize_tooltip = function(tooltip) {
                    var rect = tooltip.elem.getBoundingClientRect();
                    var doc = document.documentElement, scrollPosition = rect.top - ((window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0));
                    if (scrollPosition < 40) {
                        tooltip.tip.className = tooltip.tip.className.replace(/ ?(_above|_below) ?/g, '') + ' _below';
                    } else {
                        tooltip.tip.className = tooltip.tip.className.replace(/ ?(_above|_below) ?/g, '') + ' _above';
                    }
                };
                var resize_tooltips = function() {
                    if (_removed) return;
                    for (var i = 0; i < tooltips.length; i++) {
                        if (!tooltips[i].no_arrow) resize_tooltip(tooltips[i]);
                    }
                };
                var validate_field = function(elem, remove) {
                    if ( elem.className.includes('recaptcha') ) {
                        if ( grecaptcha.getResponse() === '' ) {
                            elem.setAttribute('required', 'required'); 
                        }
                        else {
                            elem.removeAttribute('required');
                        }
                    }
                    var tooltip = null, value = elem.value, no_error = true;
                    remove ? remove_tooltip(elem) : false;
                    if (elem.type != 'checkbox') elem.className = elem.className.replace(/ ?_has_error ?/g, '');
                    if (elem.getAttribute('required') !== null) {
                        if (elem.type == 'radio' || (elem.type == 'checkbox' && /any/.test(elem.className))) {
                            var elems = form_to_submit.elements[elem.name];
                            if (!(elems instanceof NodeList || elems instanceof HTMLCollection) || elems.length <= 1) {
                                no_error = elem.checked;
                            }
                            else {
                                no_error = false;
                                for (var i = 0; i < elems.length; i++) {
                                    if (elems[i].checked) no_error = true;
                                }
                            }
                            if (!no_error) {
                                tooltip = create_tooltip(elem, "Please select an option.");
                            }
                        } else if (elem.type =='checkbox') {
                            var elems = form_to_submit.elements[elem.name], found = false, err = [];
                            no_error = true;
                            for (var i = 0; i < elems.length; i++) {
                                if (elems[i].getAttribute('required') === null) continue;
                                if (!found && elems[i] !== elem) return true;
                                found = true;
                                elems[i].className = elems[i].className.replace(/ ?_has_error ?/g, '');
                                if (!elems[i].checked) {
                                    no_error = false;
                                    elems[i].className = elems[i].className + ' _has_error';
                                    err.push("Checking %s is required".replace("%s", elems[i].value));
                                }
                            }
                            if (!no_error) {
                                tooltip = create_tooltip(elem, err.join('<br/>'));
                            }
                        } else if (elem.tagName == 'SELECT') {
                            var selected = true;
                            if (elem.multiple) {
                                selected = false;
                                for (var i = 0; i < elem.options.length; i++) {
                                    if (elem.options[i].selected) {
                                        selected = true;
                                        break;
                                    }
                                }
                            } else {
                                for (var i = 0; i < elem.options.length; i++) {
                                    if (elem.options[i].selected && !elem.options[i].value) {
                                        selected = false;
                                    }
                                }
                            }
                            if (!selected) {
                                elem.className = elem.className + ' _has_error';
                                no_error = false;
                                tooltip = create_tooltip(elem, "Please select an option.");
                            }
                        } else if (value === undefined || value === null || value === '') {
                            elem.className = elem.className + ' _has_error';
                            no_error = false;
                            tooltip = create_tooltip(elem, "This field is required.");
                        }
                    }
                    if (no_error && elem.name == 'email') {
                        if (!value.match(/^[\+_a-z0-9-'&=]+(\.[\+_a-z0-9-']+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i)) {
                            elem.className = elem.className + ' _has_error';
                            no_error = false;
                            tooltip = create_tooltip(elem, "Enter a valid email address.");
                        }
                    }
                    if (no_error && /date_field/.test(elem.className)) {
                        if (!value.match(/^\d\d\d\d-\d\d-\d\d$/)) {
                            elem.className = elem.className + ' _has_error';
                            no_error = false;
                            tooltip = create_tooltip(elem, "Enter a valid date.");
                        }
                    }
                    tooltip ? resize_tooltip(tooltip) : false;
                    return no_error;
                };
                var needs_validate = function(el) {
                    if(el.getAttribute('required') !== null){
                        return true
                    }
                    if(el.name === 'email' && el.value !== ""){
                        return true
                    }
                    return false
                };
                var validate_form = function(e) {
                    var err = form_to_submit.querySelector('._form_error'), no_error = true;
                    if (!submitted) {
                        submitted = true;
                        for (var i = 0, len = allInputs.length; i < len; i++) {
                            var input = allInputs[i];
                            if (needs_validate(input)) {
                                if (input.type == 'text') {
                                    addEvent(input, 'blur', function() {
                                        this.value = this.value.trim();
                                        validate_field(this, true);
                                    });
                                    addEvent(input, 'input', function() {
                                        validate_field(this, true);
                                    });
                                } else if (input.type == 'radio' || input.type == 'checkbox') {
                                    (function(el) {
                                        var radios = form_to_submit.elements[el.name];
                                        for (var i = 0; i < radios.length; i++) {
                                            addEvent(radios[i], 'click', function() {
                                                validate_field(el, true);
                                            });
                                        }
                                    })(input);
                                } else if (input.tagName == 'SELECT') {
                                    addEvent(input, 'change', function() {
                                        validate_field(this, true);
                                    });
                                } else if (input.type == 'textarea'){
                                    addEvent(input, 'input', function() {
                                        validate_field(this, true);
                                    });
                                }
                            }
                        }
                    }
                    remove_tooltips();
                    for (var i = 0, len = allInputs.length; i < len; i++) {
                        var elem = allInputs[i];
                        if (needs_validate(elem)) {
                            if (elem.tagName.toLowerCase() !== "select") {
                                elem.value = elem.value.trim();
                            }
                            validate_field(elem) ? true : no_error = false;
                        }
                    }
                    if (!no_error && e) {
                        e.preventDefault();
                    }
                    resize_tooltips();
                    return no_error;
                };
                addEvent(window, 'resize', resize_tooltips);
                addEvent(window, 'scroll', resize_tooltips);
                window._old_serialize = null;
                if (typeof serialize !== 'undefined') window._old_serialize = window.serialize;
                _load_script("//d3rxaij56vjege.cloudfront.net/form-serialize/0.3/serialize.min.js", function() {
                    window._form_serialize = window.serialize;
                    if (window._old_serialize) window.serialize = window._old_serialize;
                });
                var form_submit = function(e) {
                    e.preventDefault();
                    if (validate_form()) {
                        // use this trick to get the submit button & disable it using plain javascript
                        document.querySelector('#_form_4_submit').disabled = true;
                        var serialized = _form_serialize(document.getElementById('_form_4_'));
                        var err = form_to_submit.querySelector('._form_error');
                        err ? err.parentNode.removeChild(err) : false;
                        _load_script('https://frifeldt.activehosted.com/proc.php?' + serialized + '&jsonp=true');
                    }
                    return false;
                };
                addEvent(form_to_submit, 'submit', form_submit);
            })();
        }
    };
}() );
